import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setCategoryOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`font-heading text-2xl font-bold transition-colors ${
              scrolled || !isHome ? 'text-primary-500' : 'text-white'
            }`}>
              八仔漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/90 hover:text-white'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-500'
                    : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/90 hover:text-white'
                }`}
              >
                分类
                <i className={`ri-arrow-down-s-line text-sm transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 bg-background-50 rounded-lg border border-background-200/70 py-2 w-40 shadow-lg">
                  {comicCategories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                      className="block px-4 py-2 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/90 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md ${
              scrolled || !isHome ? 'text-foreground-700' : 'text-white'
            }`}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 py-2">首页</Link>
            <div className="border-t border-background-200/50 pt-2">
              <p className="text-xs text-foreground-500 mb-2 px-1">分类浏览</p>
              <div className="flex flex-wrap gap-2">
                {comicCategories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                    className="px-3 py-1.5 rounded-full text-xs bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link to="/about" className="text-sm font-medium text-foreground-700 py-2 border-t border-background-200/50">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}